<template>
    <transition name="slide_fade_menu">
        <div class="menu_main" v-if="stateMenu">
            <div class="menu_main__content">
                <div class="menu_main__container">
                    <div class="menu_main__header">
                        <a :href="urlHome">
                            <img class="menu_main__header_logo" src="/images/getorder_logo.svg">
                        </a>
                        <div v-if="!isMobileScreen" class="menu_main__header_close cursor_pointer"
                             @click.prevent="clickClose">
                            <svg height="24" width="24">
                                <use xlink:href="/icons/base.svg#close"></use>
                            </svg>
                        </div>
                        <logo_user
                            v-if="isMobileScreen"
                            :key="'logo_user'"
                        />
                    </div>
                    <div class="menu_main__list">
                        <menu_main_item
                            v-for="item in menuMainItems"
                            :key="'menu_main_item_'+item.name"
                            :item="item"
                        />
                    </div>
                </div>
                <button class="menu_main__button_back" @click.prevent="clickClose">
                    <svg>
                        <use xlink:href="/icons/base.svg#button_back_round"></use>
                    </svg>
                </button>

            </div>
        </div>
    </transition>
    <div v-if="stateMenu" class="modal_shadow">
        <div class="modal_shadow__overlay">
        </div>
    </div>
</template>

<script>

import menu_main_item from "./MenuMainItem.vue";
import {createHelpers} from "vuex-map-fields";
import {screenSize} from "../../../mixins/screenSize";
import logo_user from "../../heading/LogoUser.vue";
import {touchEvent} from "../../../mixins/touchEvent"
import {getFullUrl} from "../../../helpers/urlFunctions";
import  {getStateMenu, setStateMenu} from "../../../helpers/menuState";

const {mapFields: mUser} = createHelpers({
    getterType: 'user/getUserField',
    mutationType: 'user/updateUserField',
})

export default {
    name: "menu_main",
    mixins: [screenSize, touchEvent],
    emits: ['close_menu_main', 'select_item_rest'],
    components: {logo_user, menu_main_item},
    data() {
        return {
            isLoadMenu: true,
            stateMenu: false,
        }
    },
    created() {
    },
    beforeMount() {
        this.stateMenu = getStateMenu();

        EventBus.$on('active_menu', this.activeMenu);
        EventBus.$on('open_menu', this.openMenu);
        EventBus.$on('load_menu_main', this.loadMenu);
        EventBus.$on('click_item_menu_main', this.clickItem);
    },
    beforeUnmount() {
        EventBus.$off('active_menu', this.activeMenu);
        EventBus.$off('open_menu', this.openMenu);
        EventBus.$off('load_menu_main', this.loadMenu);
        EventBus.$off('click_item_menu_main', this.clickItem);
    },
    methods: {
        touchStartEvent(){
            if(this.touchElementClass === 'modal_shadow__overlay') {
                setTimeout(() => {
                    this.clickClose();
                }, 200);
            }
        },
        loadMenu() {
            //this.menuMainItems.forEach(item => item === this.activeItemMenuMain ? item.isSelect = true : item.isSelect = false);
        },
        clickItem(itemMenu) {
            this.$store.dispatch('user/CLICK_ITEM_MENU_MAIN', itemMenu);

        },
        clickClose() {
            setStateMenu(false);
            this.stateMenu = false;
        },
        openMenu(){
            setStateMenu(true);
            this.stateMenu = true;
        },
        activeMenu(stateMenu) {
            this.stateMenu = stateMenu;
        },
        moveTouchLeft() {
            this.clickClose();
        },
    },
    computed: {
        ...mUser([
            'user',
            'errorMessageUser',
            'menuMainItems',
            'activeItemMenuMain',
        ]),
        userFirstCharacter() {
            if (this.user.client.organization && this.user.client.organization !== '') {
                return this.user.client.organization[0].toUpperCase();
            }
            return 'U';
        },
        urlHome() {
            return getFullUrl('/');
        },
    }
}
</script>
